<template>
  <header class="ios">
    <ion-toolbar class="header">
      <a href="#" @click.prevent="goHome" slot="start" style="max-width: 157px">
        <b-img  :src="item.src" alt="logo"></b-img>
      </a>
      <MenuMain/>


      <!-- IF DESKTOP -->
      <button class="notifications" v-b-toggle.sidebar-notifications  :class="{some:notifications}" slot="end">
        <i class="far fa-bell"></i>
        <span>{{notifications}}</span>
      </button>
      <!-- IF DESKTOP -->


      <!-- IF DESKTOP -->
      <button class="btn-profile" v-b-toggle.sidebar-profile  slot="end" >
        <div class="back"></div>
        <div class="initial">
          {{initial}}
        </div>
      </button>
      <!-- IF DESKTOP -->


    </ion-toolbar>

    <!-- <b-sidebar id="sidebar-profile" right shadow backdrop no-header width="360px" v-if="!isMobile"> -->
    <b-sidebar id="sidebar-profile" right no-header width="100vw" v-if="isMobile">
      <ProfileHome></ProfileHome>
    </b-sidebar>
    <b-sidebar id="sidebar-profile" right shadow backdrop no-header width="360px" v-else>
      <ProfileHome></ProfileHome>
    </b-sidebar>

    <b-sidebar id="sidebar-notifications" right no-header width="100vw" v-if="isMobile">
      <NotificationsHome></NotificationsHome>
    </b-sidebar>
    <b-sidebar id="sidebar-notifications" right shadow backdrop no-header width="360px" v-else>
      <NotificationsHome></NotificationsHome>
    </b-sidebar>
  </header>

</template>

<script>
import MenuMain from './menu/MenuMain'
import { mapGetters } from 'vuex'
import ProfileHome from '../../components/pages/sub_category/profile/ProfileHome'
import NotificationsHome from '../../components/pages/sub_category/notifications/NotificationsHome'
import ApiAuthenticationService from "@/services/ApiAuthenticationService";

export default {
  name: "Navbar",
  components:{
    MenuMain,
    ProfileHome,
    NotificationsHome
  },
  data(){
    return {
      item:{
        src:'/img/logo.svg'
      },
      notifications:null,
      isMobile:false,
      initial:'',
      isLoadingInitial:true,
      currentType: null
    }
  },
  computed: {
    ...mapGetters([
      'getNotifications',
      'getInitial',
      'getCodePtf',
      'getCurrentCodePtf',
      'getIsMobile'
    ])
  },
  created (){
    this.getData().then(() => {
      this.isLoadingInitial = false;
    });
    this.currentType = ApiAuthenticationService.getCurrentUser().type;
  },
  methods: {
    incrementNotifications: function (){
      this.$store.dispatch('incrementNotifications')
    },
    disconnect: function (){
      this.$store.dispatch('disconnect');
    },
    async getData(){
      this.notifications = this.getNotifications;
      this.isMobile = this.getIsMobile;
      //GET INITIAL
      this.initial = await this.getInitial;
      if(this.getCurrentCodePtf == null && this.getCodePtf && this.getCodePtf.length > 0){
        this.$store.dispatch('setCurrentCodePtf',this.getCodePtf[0]);
      }
    },
    openSlideOut:function (){
    // console.log('OPEN SLIDEOUT');
    },
    goHome(){
      if(ApiAuthenticationService.getCurrentUser().type == 'CONFIG_COLLABORATEUR'){
        this.$router.push({name:'challengesHome'}).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            // console.log(err);
          }
        });
      } else {
        this.$router.push({name:'resume_home'}).catch(err => {
          // Ignore the vuex err regarding  navigating to the page they are already on.
          if (
              err.name !== 'NavigationDuplicated' &&
              !err.message.includes('Avoided redundant navigation to current location')
          ) {
            // But print any other errors to the console
            // console.log(err);
          }
        });
      }
    }
  },
  watch: {
    getNotifications() {
      this.notifications = this.getNotifications;
    },
    getIsMobile(){
      this.isMobile = this.getIsMobile;
    }
  }
}
</script>
